module.exports = __webpack_public_path__ + "img/boss-bg-h.1f7cd88f.jpg";